/**
 * Swing parity: RendererHelper.parseColumnWidth
 * — число без «px» = доля (part) в распределении остатка ширины таблицы;
 * — «50px» = фиксированная ширина в пикселях.
 */
export type TableColumnWidthSpec = {
  wasSet: boolean
  value: number | null
  isPart: boolean
  isFixed: boolean
}

export function parseTableColumnWidth(
  raw: unknown,
  constantColumnWidth?: unknown,
): TableColumnWidthSpec {
  const isFixed =
    constantColumnWidth === true ||
    String(constantColumnWidth ?? '').trim().toLowerCase() === 'true' ||
    String(constantColumnWidth ?? '').trim() === '1'

  const text = String(raw ?? '').trim()
  if (!text) {
    return { wasSet: false, value: null, isPart: true, isFixed }
  }

  if (text.toLowerCase().includes('px')) {
    const match = text.match(/^(\d+(?:\.\d+)?)\s*px$/i)
    const px = match ? Number(match[1]) : Number.NaN
    if (!Number.isFinite(px)) {
      return { wasSet: false, value: null, isPart: true, isFixed }
    }
    return { wasSet: true, value: px, isPart: false, isFixed }
  }

  const normalized = text.endsWith('%') ? text.slice(0, -1).trim() : text
  const part = Number(normalized)
  if (!Number.isFinite(part) || part <= 0) {
    return { wasSet: false, value: null, isPart: true, isFixed }
  }
  return { wasSet: true, value: part, isPart: true, isFixed }
}

/** Парсит только явную ширину в px (для listbox-иконок и т.п.). */
export function parseTableColumnWidthPx(raw: unknown): number | null {
  const spec = parseTableColumnWidth(raw)
  if (!spec.wasSet || spec.isPart || spec.value == null) return null
  return spec.value
}
